<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">

                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row mb-3">
                                        <h4 style="margin-right: 5px" class="float-start">{{$t("cmlDetailSumStrgQty") }}</h4>
                                    </div>

                                    <div class="card-body">
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('idBillingDetail') }}</label>
                                                <input type="text" class="form-control" id="idBillingDetail"
                                                :placeholder="$t('idBillingDetail')" v-model="forms.idBillingDetail"
                                                disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{$t('idBillingHeader')}}</label>
                                                <input type="text" class="form-control" id="idBillingHeader"
                                                :placeholder="$t('idBillingHeader')" v-model="forms.idBillingHeader"
                                                disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('SAPMaterialCode') }}</label>
                                                <input type="text" class="form-control" id="SAPMaterialCode"
                                                :placeholder="$t('SAPMaterialCode')" v-model="forms.SAPMaterialCode"
                                                disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{$t('SAPDivision')}}</label>
                                                <input type="text" class="form-control" id="SAPDivision"
                                                :placeholder="$t('SAPDivision')" v-model="forms.SAPDivision" disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('chargeCategory_txt') }}</label>
                                                <input type="text" class="form-control" id="chargeCategory"
                                                :placeholder="$t('chargeCategory_txt')" v-model="forms.chargeCategory"
                                                disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{$t('chargeType_txt')}}</label>
                                                <input type="text" class="form-control" id="chargeType"
                                                :placeholder="$t('chargeType_txt')" v-model="forms.chargeType"
                                                disabled />
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">{{$t('rateBaseDesc_txt')}}</label>
                                                <input type="text" class="form-control" id="rateBaseDesc"
                                                :placeholder="$t('rateBaseDesc_txt')" v-model="forms.rateBaseDesc"
                                                disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('qtyCharge') }}</label>
                                                <input type="text" class="form-control" id="qtyCharge"
                                                :placeholder="$t('qtyCharge')" v-model="forms.qtyCharge" disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{$t('rate')}}</label>
                                                <input type="text" class="form-control" id="rate" :placeholder="$t('rate')"
                                                v-model="forms.rate" disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('amountCategory') }}</label>
                                                <input type="text" class="form-control" id="amountCategory"
                                                :placeholder="$t('amountCategory')" v-model="forms.amountCategory"
                                                disabled />
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label">{{ $t('remarks_txt') }}</label>
                                                <input type="text" class="form-control" id="remark"
                                                :placeholder="$t('remarks_txt')" v-model="forms.remark"
                                                disabled />
                                            </div>
                                        </div>
                                    </div>

                                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="downloadData()">
                                        <span class="mdi mdi-download h4"></span>
                                        {{ $t("downloadData") }} .xlsx
                                    </button>

                                    <button class="
                                    btn btn-primary
                                    text-light
                                    fw-bolder
                                    btn-icon-text
                                    " @click="backForm" type="button">
                                        <i class="link-icon mdi mdi-arrow-left"></i>
                                        {{ $t("backMess") }}
                                    </button>

                                </div>

                                <div class="card-body">
                                    <vue-good-table title="list-billing-cml-billing-detail-summary-storage-muid-charge"
                                        ref="list-billing-cml-billing-detail-summary-storage-muid-charge" mode="remote"
                                        styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                                        :isLoading.sync="isLoading" :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                            position: 'top',
                                        }" :rows="rows" :columns="columns">

                                        <template slot="column-filter" slot-scope="{ column }">
                                            <span v-if="column.filterOptions.customFilter">

                                                <span v-if="column.field == 'stockDate'">

                                                    <date-range-picker style="width:100%" @update="trxDateChange"
                                                        control-container-class="form-control"
                                                        :locale-data="{ format: 'yyyy-mm-dd' }" v-model="trxDate"
                                                        :opens="opens" :singleDatePicker="false" :timePicker24Hour="false"
                                                        :timePicker="false" :showWeekNumbers="false">
                                                        <div slot="header" slot-scope="header" class="slot">
                                                            <a @click="cleartrxDateChange()" class="float-end"
                                                                style="margin-right: 5px;color:red;">Clear Calendar</a>
                                                            <span v-if="header.in_selection"> - in selection</span>
                                                            <br>
                                                        </div>
                                                    </date-range-picker>

                                                </span>

                                            </span>

                                        </template>


                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'actions'">

                                                -

                                            </span>
                                            <span v-else-if="props.column.field == 'amount'">
                                                {{ toCurrency(props.row.amount) }}
                                            </span>
                                            <span v-else-if="props.column.field == 'rate'">
                                                {{ toCurrency(props.row.rate) }}
                                            </span>
                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>

                                    </vue-good-table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
    name: "CmlBillDetSummStrgQty",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker
    },
    data() {
        return {
            opens: "center",
            locale: {
                format: "yyyy-mm-dd",

            },
            trxDate: {
                startDate: null,
                endDate: null
            },
            firstDates: {
                startDate: null,
                endDate: null
            },
            highlighted: {

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            idBillingHeader: [],
            detailDivisi: [],
            totalRecords: 0,
            trxDateFrom: "",
            firstBilingDate: "",
            trxDateTo: "",
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: this.$t("idSummaryStorageQty"),
                    field: "idSummaryStorageQty",
                    width: "200px",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("idSummaryStorageQty"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("stockDate"),
                    field: "stockDate",
                    width: "300px",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: true,
                        placeholder: this.$t("stockDate"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("sumQtyOnhand"),
                    field: "sumQtyOnhand",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("sumQtyOnhand"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("sumQty"),
                    field: "sumQtyCharge",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("sumQty"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("qtyChargeDays"),
                    field: "qtyChargeDays",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("qtyChargeDays"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                        label: this.$t("additionalFlag"),
                        field: "additionalFlag",
                        thClass: 'text-center',
                        width: '100px',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("all"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },

            ],
            rows: [],
            rowsSelection: [],
            idCodeLkupsSelections: [],
            forms: {remark: "", rateBaseDesc: "", idBillingDetail: "",  idBillingHeader:"",  chargeCategory:"", chargeType:"", SAPMaterialCode:"", SAPDivision:"",  amountCategory:"" , addwho:"", editwho:"",  qtyCharge:"", rate:""},
            formsHeader: { idBillingHeader: "", tariffId: "", customerId: "", warehouseId: "", transactionToDate: "", transactionFromDate: "", status: "", amount: "", idRateHeader: "", transactionDate: "", addwho: "", editwho: "", adddate: "", editdate: "" },

        };
    },
    watch: {},
    methods: {


        selectionChanged(ev) {

            this.rowsSelection = [];
            this.idCodeLkupsSelections = [];
            this.rowsSelection = ev.selectedRows;

            this.rowsSelection.forEach((item) => {
                this.idCodeLkupsSelections.push(item.idSummaryStorageQty);

            });


        },

        trxDateChange() {

            if (this.trxDate.startDate && this.trxDate.endDate) {
                this.trxDateFrom = this.$moment(String(this.trxDate.startDate)).format('YYYY-MM-DD');
                this.trxDateTo = this.$moment(String(this.trxDate.endDate)).format('YYYY-MM-DD');
                this.loadItems()
            }

        },

        cleartrxDateChange() {
            this.trxDate = {
                startDate: null,
                endDate: null
            };
            this.trxDateFrom = ""
            this.trxDateTo = ""
            this.loadItems()
        },

        backForm() {
            var params = this.$onRandom(this.$route.params.idBillingHeader);
            window.location.href = "/billing-cml/billing/header/detail/" + params;
        },

        toCurrency(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'IDR'
            });
            return formatter.format(value);
        },


        downloadData() {
            var params = this.$onBehind(this.$route.params.idBillingDetail);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-bill-det-sum-strg-qty/" + params[0];
            this.isLoading = true;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            let trxDateFrom = this.trxDateFrom;
            let trxDateTo   = this.trxDateTo;

            return this.$http
                .get(
                    baseURI +
                    `?additionalFlag=${this.serverParams.columnFilters.additionalFlag}&idSummaryStorageQty=${this.serverParams.columnFilters.idSummaryStorageQty}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&download=download`,
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
        },



        // load items is what brings back the rows from server
        loadItems() {

            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo

            var params = this.$onBehind(this.$route.params.idBillingDetail);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-bill-det-sum-strg-qty/" + params[0];
            this.isLoading = true;


            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idSummaryStorageQty=${this.serverParams.columnFilters.idSummaryStorageQty}&additionalFlag=${this.serverParams.columnFilters.additionalFlag}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}`,
                    { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }

                });
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'BillingCmlController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

            this.loadData();
        },


        loadData() {
            this.isLoading = true;

            var params = this.$onBehind(this.$route.params.idBillingDetail);

            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-detail/" + params[0];
            return this.$http.get(baseURI, { timeout: 60000 }).then((response) => {

                this.isLoading = false;
                this.forms = response.data.datas;
                this.forms.amountCategory = this.toCurrency(response.data.datas.amountCategory)
                this.forms.rate = this.toCurrency(response.data.datas.rate)
                this.formsHeader = response.data.datas.bm_billing_header;

            }).catch(error => {
                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }


            });
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();
        this.loading();
    },
};

</script>
<style scoped>
.blur-content {
    filter: blur(5px);
}
</style>